<div class="d-flex flex-column align-items-center justify-content-center">
    <ion-spinner color="primary" name="dots"></ion-spinner>
</div>